export { default as CashIcon } from './CashIcon';
